import {useQuery} from "@apollo/client";
import {useContext, useEffect, useState} from "react";

import {Divider} from "@/components/divider/Divider.tsx";
import {GQL_SUBSCRIPTION_EMAIL_DOMAINS} from "@/lib/queries/statuspages.ts";
import {SubscriptionEmailDomainResult, SubscriptionEmailDomainType} from "@/lib/types/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {AddDomainForm} from "@/pages/statuspages/tabs/subscribers/components/allow-block-list/AddDomainForm.tsx";
import {AllowBlockListTable} from "@/pages/statuspages/tabs/subscribers/components/allow-block-list/AllowBlockListTable.tsx";

export interface AllowBlockListTabContentProps {
  domainType: SubscriptionEmailDomainType;
}

export const AllowBlockListTabContent = ({domainType}: AllowBlockListTabContentProps) => {
  const {statusPage} = useContext(StatusPageContext);
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({});

  const {data} = useQuery<SubscriptionEmailDomainResult>(GQL_SUBSCRIPTION_EMAIL_DOMAINS, {
    variables: {
      emailDomainType: domainType,
      statusPageID: statusPage.id,
    },
  });

  useEffect(() => {
    setRowSelection({});
  }, [domainType, setRowSelection]);

  return (
    <>
      <AddDomainForm domainType={domainType} key={`add-${domainType}-domain-form`} />
      <Divider className="my-4" />
      <AllowBlockListTable
        domainType={domainType}
        items={data?.subscriptionEmailDomains.items || []}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
      />
    </>
  );
};
